// Firebase client configuration, sourced from VITE_FIREBASE_* env vars.
// All values here are public client identifiers (safe to ship in the bundle);
// data access is protected by Firebase security rules, not by these values.

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Web-push VAPID key used by getToken() to mint an FCM registration token.
export const vapidKey: string = import.meta.env.VITE_FIREBASE_VAPID_KEY;

export default firebaseConfig;
